import React from 'react';
import classnames from 'classnames';
import { Steps } from 'antd';
import './siriusSteps.scss';
export const prefixCls = 'sirius-steps';
const SiriusSteps = props => {
    const { className } = props;
    const stepsClassName = classnames(prefixCls, className);
    return React.createElement(Steps, Object.assign({ className: stepsClassName }, props));
};
SiriusSteps.Step = Steps.Step;
export default SiriusSteps;
